module.exports = __webpack_public_path__ + "img/suse-booth-video.5f05292d.png";